export default (props, vars) => {
  return !vars?.isInViewOfferDetailsMode;
};
